import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import type { RootReduxState } from 'app/shared/flux/reducers';
import HpBreadcrumb from 'app/shared/modules/HpBreadcrumb';
import controller from './controller';

type AreaBreadcrumbsOwnProps = {
  className?: string | null;
};

type AreaBreadcrumbsStateProps = {
  area: RootReduxState['area']['area'];
  currentListing: RootReduxState['currentListingDetails']['currentListing'];
  filter: RootReduxState['filter'];
};

type AreaBreadcrumbsProps = AreaBreadcrumbsOwnProps & AreaBreadcrumbsStateProps & RouteComponentProps;

class AreaBreadcrumbs extends React.Component<AreaBreadcrumbsProps> {
  render() {
    const { area, className = null, currentListing, filter } = this.props;
    const LIMIT = 3;

    const breadcrumbs = controller.getBreadcrumbs({
      area,
      filter,
      currentListing,
    });

    return (
      <div className={cx('AreaBreadcrumbs', className)}>
        {Boolean(breadcrumbs.length) && <HpBreadcrumb breadcrumbs={breadcrumbs.slice(0, LIMIT)} />}
      </div>
    );
  }
}

const mapStateToProps = (state: RootReduxState): AreaBreadcrumbsStateProps => {
  return {
    area: state.area.area,
    currentListing: state.currentListingDetails.currentListing,
    filter: state.filter,
  };
};

export default withRouter(
  connect(mapStateToProps)(AreaBreadcrumbs) as React.ComponentType<AreaBreadcrumbsOwnProps & RouteComponentProps>,
);
